import { Formik } from 'formik';
import { useCallback } from 'react';
import { useModal } from 'yoso';
import { BaseError } from '~/components/Error/BaseError';
import { EvolveForm } from '~/components/Evolve/Form/EvolveForm';
import {
  EvolveValues,
  useProceedEvolve,
  useValidate,
} from '~/components/Evolve/Form/EvolveForm.hooks';
import { t } from '~/components/I18n';
import { Confirm } from '~/components/Modal/Confirm/Confirm';

export type EvolveFormikProps = {
  initialValues?: Partial<EvolveValues>;
  onSuccess?: () => void;
  onError?: (error: BaseError) => void;
};

const defaultInitialValues: EvolveValues = {
  tokenIdList: [undefined, undefined, undefined],
};

export const EvolveFormik = ({ initialValues, onSuccess, onError }: EvolveFormikProps) => {
  const { open } = useModal();
  const { mutateAsync } = useProceedEvolve({ onSuccess, onError });
  const validate = useValidate();
  const onSubmit = useCallback(
    async (values, { resetForm, validateForm }) => {
      const { confirmed } = await open(
        <Confirm
          description={t('citizen_evolve_confirm_desc')}
          confirmText={t('citizen_button_title_continue')}
          dismissText={t('citizen_confirm_cancel')}
        />
      );
      if (confirmed) {
        await mutateAsync(values);
        resetForm();
        await validateForm();
      }
    },
    [mutateAsync, open]
  );
  return (
    <Formik
      initialValues={{ ...defaultInitialValues, ...initialValues }}
      validateOnMount={true}
      validate={validate}
      onSubmit={onSubmit}>
      <EvolveForm />
    </Formik>
  );
};
